import {mapState} from 'vuex';
import {updateTagsView} from "@js/parts/search/functions/searchfilterbox/updateTagsView";
import {triggerDocumentEvent} from "@js/globalFunctions/events";
import {rewriteUrlPaging} from "@js/parts/search/functions/paging/rewrites";
import {updateSearchCountDisplay} from "@js/parts/search/functions/updateSearchCountDisplay";
import {stopSearchCountLoader} from "@js/globalFunctions/loaders";
export default {
	computed: {
		...mapState({
			isMainSearch: 'isMainSearch',
			search: 'search',
			page: 'page',
			maxPages: 'maxPages',
			totalCount: 'totalCount'
		})
	},
	methods: {
		/***********************************************************************
		     .-.-.   .-.-.   .-.-.   .-.-.   .-.-.   .-.-.   .-.-.   .-.-
		     / / \ \ / / \ \ / / \ \ / / \ \ / / \ \ / / \ \ / / \ \ / / \
		     `-'   `-`-'   `-`-'   `-`-'   `-`-'   `-`-'   `-`-'   `-`-'
	                                EVENT TRIGGERS

		 ************************************************************************/
		mountMainSearch(){
			window.addEventListener('searchChanged', this.searchChanged);
			window.addEventListener('loadedMore', this.loadedMore);
			window.addEventListener('refreshedSearchHtml', this.performAfterSearchActions);
		},
		unmountMainSearch(){
			window.removeEventListener('searchChanged', this.searchChanged);
			window.removeEventListener('loadedMore', this.loadedMore);
			window.removeEventListener('refreshedSearchHtml', this.performAfterSearchActions);
		},
		triggerSearchFinishedEvents(initial, newSearch)
		{
			this.$nextTick(() => {
				if(initial === false && newSearch === false)
				{
					triggerDocumentEvent('loadedMore');
				}
				else if(initial)
				{
					triggerDocumentEvent('updateRequiredScripts',{includeCss: true});
					triggerDocumentEvent('refreshedSearchHtml');
					triggerDocumentEvent('triggerResourceCondition',{includeCss: true,where:'search_visible'});
					if(this.isMainSearch)
					{
						stopSearchCountLoader();
						updateSearchCountDisplay(this.totalCount,0)

					}
				}
				else
				{
					triggerDocumentEvent('refreshedSearchHtml');
					if(this.isMainSearch)
					{
						stopSearchCountLoader();
						const currentCount = parseInt($('#searchCount').text());
						updateSearchCountDisplay(this.totalCount,currentCount)
					}
				}
			});
		},



		/***********************************************************************
		     .-.-.   .-.-.   .-.-.   .-.-.   .-.-.   .-.-.   .-.-.   .-.-
		     / / \ \ / / \ \ / / \ \ / / \ \ / / \ \ / / \ \ / / \ \ / / \
		     `-'   `-`-'   `-`-'   `-`-'   `-`-'   `-`-'   `-`-'   `-`-'
	                                EVENT FUNCTIONS

		 ************************************************************************/
		performAfterSearchActions()
		{
			dataholder.maxPaging = this.maxPages;
			rewriteUrlPaging(this.page,false)
		},
		searchChanged(){
			this.updateSearchParameters();
			updateTagsView();
		},
		loadedMore(){
			rewriteUrlPaging(this.page)
		},





		/***********************************************************************
		     .-.-.   .-.-.   .-.-.   .-.-.   .-.-.   .-.-.   .-.-.   .-.-
		     / / \ \ / / \ \ / / \ \ / / \ \ / / \ \ / / \ \ / / \ \ / / \
		     `-'   `-`-'   `-`-'   `-`-'   `-`-'   `-`-'   `-`-'   `-`-'
	                                    HELPERS

		 ************************************************************************/
		updateSearchParameters(overwriteWithDefault) {
			overwriteWithDefault = typeof overwriteWithDefault === 'boolean' ? overwriteWithDefault : false
			const updatedParameters = searchParameters.getParameters();
			if(overwriteWithDefault)
			{
				Object.keys(this.search.defaultParameters).forEach((key) => {
					updatedParameters[key] = this.search.defaultParameters[key];
				});
			}
			this.$store.commit('updateSearchParameters',updatedParameters);
			Object.keys(updatedParameters).forEach((key) => {
				if(key !== 'none')
					searchParameters.setParameter(key,updatedParameters[key][0])
			});
		},
	},
	beforeDestroy(){
		this.unmountMainSearch();
	},
	mounted(){
		if(this.isMainSearch)
		{
			this.mountMainSearch();
			this.updateSearchParameters(true);
			updateTagsView();
			this.fetchPage();
		}
	}
}
